import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from './ErrorBoundary';
import ListMenu from './menuTypes/ListMenu';
import ThirdLevelMenu from './menuTypes/ThirdLevelMenu';
import QuestionMenu from './menuTypes/QuestionMenu';
import VerticalSelectMenu from './menuTypes/VerticalSelectMenu';
import SetMenu from './menuTypes/SetMenu';
import InputMenu from './menuTypes/InputMenu';
import KeyboardMenu from './menuTypes/KeyboardMenu';
import ChangeResetMenu from './menuTypes/ChangeResetMenu';
import BigSelectMenu from './menuTypes/BigSelectMenu';
import OffMenu from './menuTypes/OffMenu';
import SetCancelMenu from './menuTypes/SetCancelMenu';
import TimeZoneMenu from './menuTypes/TimeZoneMenu';
import DateTimeMenu from './menuTypes/DateTimeMenu';
import SelectionTreeMenu from './menuTypes/SelectionTreeMenu';
import CloseMenu from './menuTypes/CloseMenu';
import SecondLevelMenu from './menuTypes/SecondLevelMenu';
import FirstLevelMenu from './menuTypes/FirstLevelMenu';
import RegisterMenu from './menuTypes/RegisterMenu';

const menuTypes = {
  question: QuestionMenu,
  vertical_select: VerticalSelectMenu,
  list: ListMenu,
  change_reset: ChangeResetMenu,
  input: InputMenu,
  big_select: BigSelectMenu,
  selection_tree: SelectionTreeMenu,
  off: OffMenu, 
  date_time: DateTimeMenu, 
  time_zone: TimeZoneMenu, 
  select: SetMenu,
  select_cancel: SetCancelMenu, 
  keyboard: KeyboardMenu,
  register: RegisterMenu,
  undefined: ListMenu, 
}

const CameraMenu = ({
  dataMenu, 
  menuLevel, 
  firstLevelIndex, 
  secondLevelIndex, 
  thirdLevelIndex, 
  fourthLevelIndex, 
  fifthLevelIndex, 
  sixLevelIndex,
  showSubList
}) => {

  const firstLevelMenu = Object.keys(dataMenu);
  const firstLevelItemObject = dataMenu[firstLevelMenu[firstLevelIndex]];
  const firstLevelItemName = firstLevelItemObject.name;

  let secondLevelMenu;
  let secondLevelItemObject;

  let thirdLevelMenu;
  let thirdLevelItemObject;

  let fourthLevelMenu;
  let fourthLevelItemObject;

  let fifthLevelItemsArray;
  let sixthLevelObject;

  if(firstLevelItemObject.settings) {
    secondLevelMenu = Object.keys(firstLevelItemObject.settings);
    secondLevelItemObject = firstLevelItemObject.settings[secondLevelMenu[secondLevelIndex]];
    thirdLevelMenu = Object.keys(secondLevelItemObject.settings);
    thirdLevelItemObject = secondLevelItemObject.settings[thirdLevelMenu[thirdLevelIndex]];
  }

  const menuContainer = secondLevelMenu !== undefined
    ? <>
          <SecondLevelMenu
              secondLevelMenu={secondLevelMenu}
              parentItemName={firstLevelItemName}
          />
        <ErrorBoundary>
          <ThirdLevelMenu
              {...secondLevelItemObject}
              thirdLevelIndex={thirdLevelIndex}
              fourthLevelIndex={fourthLevelIndex}
              showSubList={showSubList}
          />
        </ErrorBoundary>
      </>
    : <CloseMenu menuItemName={firstLevelItemName} />
  

  const basicMenu = 
      <>  
        <FirstLevelMenu/>
        {menuContainer}
      </>

  const renderSpecificMenu = (object, index, indexChild, menuLevel, showSubList) => {
      const MenuToRender = menuTypes[object.type];
      return (
        <ErrorBoundary>
          <MenuToRender {...object} index={index} indexChild={indexChild} menuLevel={menuLevel} showSubList={showSubList} />
        </ErrorBoundary>
      );
  };

  let menuToRender;
  switch(menuLevel) {
    default:
    case 1:
    case 3: 
      menuToRender = basicMenu;
      break;
    case 4:
      menuToRender = renderSpecificMenu(thirdLevelItemObject, fourthLevelIndex, fifthLevelIndex, menuLevel, showSubList); 
      break;
    case 5: 
      if (thirdLevelItemObject.settings !== undefined) {
        fourthLevelMenu = Object.keys(thirdLevelItemObject.settings);
        fourthLevelItemObject = thirdLevelItemObject.settings[fourthLevelMenu[fourthLevelIndex]];
      }
      menuToRender = renderSpecificMenu(fourthLevelItemObject, fifthLevelIndex, sixLevelIndex, menuLevel);
      break;
    case 6:
      fourthLevelMenu = Object.keys(thirdLevelItemObject.settings);
      fourthLevelItemObject = thirdLevelItemObject.settings[fourthLevelMenu[fourthLevelIndex]];
      fifthLevelItemsArray = Object.keys(fourthLevelItemObject.settings)
      sixthLevelObject = fourthLevelItemObject.settings[fifthLevelItemsArray[fifthLevelIndex]]; 
      menuToRender = renderSpecificMenu(sixthLevelObject, sixLevelIndex); 
      break;
  }

  return menuToRender;

}

CameraMenu.propTypes = {
  dataMenu: PropTypes.object.isRequired,
  menuLevel: PropTypes.number.isRequired,
  firstLevelIndex: PropTypes.number.isRequired,
  secondLevelIndex: PropTypes.number.isRequired, 
  thirdLevelIndex: PropTypes.number,
  fourthLevelIndex: PropTypes.number,
  fifthLevelIndex: PropTypes.number,
  sixLevelIndex: PropTypes.number,
  showSubList: PropTypes.bool.isRequired,
}

export default CameraMenu;
